import React from 'react';

import { Container } from './Tab.styles';

export function Tab({ children, ...rest }) {
  return <Container {...rest}>{children}</Container>;
}
